import { findingRenderMethod_Flat } from '../finding-render-method/index.js';
import { findingSortMethod_Alphabet } from '../finding-sort-method/index.js';
import { findingViewSectionType_ByOrder, findingViewSectionType_FishBone, findingViewSectionType_Flat, findingViewSectionType_Graph, sectionRenderMethod_Contained, sectionRenderMethod_Inline } from './types.js';
export const cleanFindingViewSection = Object.freeze({
    label: 'New Section',
    type: findingViewSectionType_Flat,
    data: {
        findingRenderMethod: findingRenderMethod_Flat,
        findingSortMethod: findingSortMethod_Alphabet,
    },
    config: {
        showChiefComplaints: true,
        showOnlyChiefComplaints: false,
        allowFindingEdit: false,
        alwaysVisible: false,
        fillPanelHeight: false,
        renderPrevFindings: false,
        showFindingInfoTooltip: false,
        spanPanelWidth: false,
    }
});
export const findingViewSection_RenderMethodLabelMap = {
    [sectionRenderMethod_Inline]: 'Inline',
    [sectionRenderMethod_Contained]: 'Contained',
};
export const findingViewSection_TypeLabelMap = {
    [findingViewSectionType_Flat]: 'Flat',
    [findingViewSectionType_ByOrder]: 'By Order',
    [findingViewSectionType_FishBone]: 'Fish Bone',
    [findingViewSectionType_Graph]: 'Graph'
};
export const findingViewSection_ConfigLabelMap = {
    showChiefComplaints: 'Show Chief Complaints',
    showOnlyChiefComplaints: 'Show Only Chief Complaints',
    spanPanelWidth: 'Span Panel Width',
    showFindingInfoTooltip: 'Show Finding Tooltip',
    renderPrevFindings: 'Render Previous Encounter Findings',
    fillPanelHeight: 'Fill Panel Height',
    alwaysVisible: 'Always Visible',
    allowFindingEdit: 'Allow Edit Findings',
    showAttributes: 'Show Attributes',
    specialAttention_Disease: 'Special Attention - Disease',
    forceShowNegative: 'Force Show Negative',
    explicitYes: 'Explicit "Yes"',
    showDate: 'Show Finding Date',
};
export const findingViewSection_ConfigInfoMap = {
    showChiefComplaints: 'Should this section display chief complaint findings.',
    showOnlyChiefComplaints: 'Should this section display ONLY chief complaint findings.',
    allowFindingEdit: 'Allow opening findings to edit.',
    alwaysVisible: 'Section will always be visible, even if it has no data to show. will cause the finding view to be always visible.',
    fillPanelHeight: 'Section will grow to fill extra height in the panel. only relevant if the finding view shows contained sections',
    spanPanelWidth: 'Section will take the full width of the panel. only relevant if the finding view shows contained sections',
    renderPrevFindings: 'Section will render findings from previous encounter along side current encounter findings, so long as there are no current encounter findings for the same variable',
    showFindingInfoTooltip: 'Findings under this section will attempt to display a tooltip on hover containing variable info and other samples. Automatically true for fishbone sections',
    showAttributes: 'Findings under this section will render attributes if they have any',
    specialAttention_Disease: 'Allow marking findings under this section as special diseases if are tagged as such.',
    forceShowNegative: 'Ignore the apps "Hide negative findings" configuration',
    explicitYes: 'Findings that have the value "Yes" will explicitly show so on screen',
    showDate: 'Findings will render their issued timestamp'
};
//# sourceMappingURL=consts.js.map